import React, { Fragment } from "react";
import { CurrencyOptions } from "../../../../../../Constants/retailer";
import { formatPriceInput } from "../../../../../../Utils/utils";

export default function TokenPriceInput({
  onChange,
  territory,
  amount,
  tokenName = "tokens",
}) {
  return (
    <Fragment>
      <label>{`Price per 100 ${tokenName}`}</label>
      <div className="price_input_container">
        <span className="price_input_unit">{CurrencyOptions[territory]}</span>
        <input
          className="form-control form-control-lg form-control-alt"
          type="number"
          name="price"
          value={formatPriceInput(amount)}
          placeholder="00.00"
          onChange={onChange}
        />
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/super_products/components/Popup/components/TokenPriceInput/index.js